<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <h6 class="pt-3">Guest Info</h6>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="firstname" id="firstname" type="text" pInputText>
            <label for="firstname">First Name</label>
            @for (validation of validationMessages.firstname; track validation) {
              <span>
                @if (form1.get('firstname').hasError(validation.type) && (form1.get('firstname').dirty || form1.get('firstname').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="lastname" id="lastname" type="text" pInputText>
            <label for="lastname">Last Name</label>
            @for (validation of validationMessages.lastname; track validation) {
              <span>
                @if (form1.get('lastname').hasError(validation.type) && (form1.get('lastname').dirty || form1.get('lastname').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="email" id="email" type="text" pInputText>
            <label for="email">Email</label>
            @for (validation of validationMessages.email; track validation) {
              <span>
                @if (form1.get('email').hasError(validation.type) && (form1.get('email').dirty || form1.get('email').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <!-- <p-inputMask formControlName="phone" id="phone" mask="(999) 999-9999" type="text">
          </p-inputMask> -->
          <input formControlName="phone" id="phone" type="text" pInputText>
          <label for="phone">Mobile Phone</label>
          @for (validation of validationMessages.phone; track validation) {
            <span>
              @if (form1.get('phone').hasError(validation.type) && (form1.get('phone').dirty || form1.get('phone').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="numAdults" id="numAdults" type="text" pInputText>
          <label for="numAdults">Adults</label>
          @for (validation of validationMessages.numAdults; track validation) {
            <span>
              @if (form1.get('numAdults').hasError(validation.type) && (form1.get('numAdults').dirty || form1.get('numAdults').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="numChildren" id="numChildren" type="text" pInputText>
          <label for="numChildren">Children</label>
          @for (validation of validationMessages.numChildren; track validation) {
            <span>
              @if (form1.get('numChildren').hasError(validation.type) && (form1.get('numChildren').dirty || form1.get('numChildren').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <h6 class="pt-3">Reservation Info</h6>


      <div class="col-lg-6">
        <span class="p-float-label w-100 mb-3">
          <p-dropdown class="w-100" [options]="reservationStatuses" formControlName="reservationStatus" optionLabel="name"
          optionValue="value" placeholder="Status"></p-dropdown>
          <label for="reservationStatus">Status</label>
          @for (validation of validationMessages.reservationStatus; track validation) {
            <span>
              @if (form1.get('reservationStatus').hasError(validation.type) && (form1.get('reservationStatus').dirty || form1.get('reservationStatus').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <p-dropdown class="w-100" [options]="reservationTypes" formControlName="reservationType" optionLabel="name"
          optionValue="value" placeholder="Type"></p-dropdown>
          <label for="reservationType">Reservation Type</label>
          @for (validation of validationMessages.reservationType; track validation) {
            <span>
              @if (form1.get('reservationType').hasError(validation.type) && (form1.get('reservationType').dirty || form1.get('reservationType').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>


      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="externalSystemName" id="externalSystemName" type="text" pInputText>
          <label for="externalSystemName">External System Name</label>
          @for (validation of validationMessages.externalSystemName; track validation) {
            <span>
              @if (form1.get('externalSystemName').hasError(validation.type) && (form1.get('externalSystemName').dirty || form1.get('externalSystemName').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="extReservationId" id="extReservationId" type="text" pInputText>
          <label for="extReservationId">External ReservationId</label>
          @for (validation of validationMessages.extReservationId; track validation) {
            <span>
              @if (form1.get('extReservationId').hasError(validation.type) && (form1.get('extReservationId').dirty || form1.get('extReservationId').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="extConfirmationId" id="extConfirmationId" type="text" pInputText>
          <label for="extConfirmationId">External ConfirmationId</label>
          @for (validation of validationMessages.extConfirmationId; track validation) {
            <span>
              @if (form1.get('extConfirmationId').hasError(validation.type) && (form1.get('extConfirmationId').dirty || form1.get('extConfirmationId').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="extHashId" id="extHashId" type="text" pInputText>
          <label for="extHashId">External HashId</label>
          @for (validation of validationMessages.extHashId; track validation) {
            <span>
              @if (form1.get('extHashId').hasError(validation.type) && (form1.get('extHashId').dirty || form1.get('extHashId').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="numNightsToNextCheckIn" id="numNightsToNextCheckIn" type="text" pInputText>
          <label for="numNightsToNextCheckIn">Num Nights To NextCheckIn</label>
          @for (validation of validationMessages.numNightsToNextCheckIn; track validation) {
            <span>
              @if (form1.get('numNightsToNextCheckIn').hasError(validation.type) && (form1.get('numNightsToNextCheckIn').dirty || form1.get('numNightsToNextCheckIn').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="numNightsFromPrevCheckOut" id="numNightsFromPrevCheckOut" type="text" pInputText>
          <label for="numNightsFromPrevCheckOut">Num Nights From PrevCheckOut</label>
          @for (validation of validationMessages.numNightsFromPrevCheckOut; track validation) {
            <span>
              @if (form1.get('numNightsFromPrevCheckOut').hasError(validation.type) && (form1.get('numNightsFromPrevCheckOut').dirty || form1.get('numNightsFromPrevCheckOut').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="qualityScore" id="qualityScore" type="text" pInputText>
          <label for="qualityScore">Quality Score</label>
          @for (validation of validationMessages.qualityScore; track validation) {
            <span>
              @if (form1.get('qualityScore').hasError(validation.type) && (form1.get('qualityScore').dirty || form1.get('qualityScore').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="numNights" id="numNights" type="text" pInputText>
          <label for="numNights">Number Of Nights</label>
          @for (validation of validationMessages.numNights; track validation) {
            <span>
              @if (form1.get('numNights').hasError(validation.type) && (form1.get('numNights').dirty || form1.get('numNights').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>



      <div class="col-lg-6">
        <span class="p-float-label w-100 mb-3">
          <p-calendar formControlName="checkInDate" inputId="checkInDate" dateFormat="yy-mm-dd" appendTo="body">
          </p-calendar>
          <label for="checkInDate">CheckIn Date</label>
          @for (validation of validationMessages.checkInDate; track validation) {
            <span>
              @if (form1.get('checkInDate').hasError(validation.type) && (form1.get('checkInDate').dirty || form1.get('checkInDate').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label w-100 mb-3">
          <p-calendar formControlName="checkOutDate" inputId="checkOutDate" dateFormat="yy-mm-dd" appendTo="body">
          </p-calendar>
          <label for="checkOutDate">CheckOut Date</label>
          @for (validation of validationMessages.checkOutDate; track validation) {
            <span>
              @if (form1.get('checkOutDate').hasError(validation.type) && (form1.get('checkOutDate').dirty || form1.get('checkOutDate').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label w-100 mb-3">
          <p-calendar formControlName="holdDate" inputId="holdDate" appendTo="body">
          </p-calendar>
          <label for="holdDate">Hold Date</label>
          @for (validation of validationMessages.holdDate; track validation) {
            <span>
              @if (form1.get('holdDate').hasError(validation.type) && (form1.get('holdDate').dirty || form1.get('holdDate').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label w-100 mb-3">
          <p-calendar formControlName="quoteDate" inputId="quoteDate" appendTo="body">
          </p-calendar>
          <label for="quoteDate">Quote Date</label>
          @for (validation of validationMessages.quoteDate; track validation) {
            <span>
              @if (form1.get('quoteDate').hasError(validation.type) && (form1.get('quoteDate').dirty || form1.get('quoteDate').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label w-100 mb-3">
          <p-calendar formControlName="saleDate" inputId="saleDate" appendTo="body">
          </p-calendar>
          <label for="saleDate">Sale Date</label>
          @for (validation of validationMessages.saleDate; track validation) {
            <span>
              @if (form1.get('saleDate').hasError(validation.type) && (form1.get('saleDate').dirty || form1.get('saleDate').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label w-100 mb-3">
          <p-calendar formControlName="closeDate" inputId="closeDate" appendTo="body">
          </p-calendar>
          <label for="closeDate">Close Date</label>
          @for (validation of validationMessages.closeDate; track validation) {
            <span>
              @if (form1.get('closeDate').hasError(validation.type) && (form1.get('closeDate').dirty || form1.get('closeDate').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label w-100 mb-3">
          <p-calendar formControlName="cancelDate" inputId="cancelDate" appendTo="body">
          </p-calendar>
          <label for="cancelDate">Cancel Date</label>
          @for (validation of validationMessages.cancelDate; track validation) {
            <span>
              @if (form1.get('cancelDate').hasError(validation.type) && (form1.get('cancelDate').dirty || form1.get('cancelDate').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="roomRatePN" id="roomRatePN" type="text" pInputText>
          <label for="roomRatePN">Room RatePN</label>
          @for (validation of validationMessages.roomRatePN; track validation) {
            <span>
              @if (form1.get('roomRatePN').hasError(validation.type) && (form1.get('roomRatePN').dirty || form1.get('roomRatePN').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="roomRateTTL" id="roomRateTTL" type="text" pInputText>
          <label for="roomRateTTL">Room RateTTL</label>
          @for (validation of validationMessages.roomRateTTL; track validation) {
            <span>
              @if (form1.get('roomRateTTL').hasError(validation.type) && (form1.get('roomRateTTL').dirty || form1.get('roomRateTTL').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>



      <div class="col-lg-6">
        <!-- <h6 for="paying">Is Paying?</h6> -->
        <div class="flex align-items-center">
          <p-checkbox [formControl]="form1.controls['paying']" inputId="paying" [binary]="true"></p-checkbox>
          <span class="reservation-nm">Is Paying?</span>
        </div>
        @for (validation of validationMessages.paying; track validation) {
          <span>
            @if (form1.get('paying').hasError(validation.type) && (form1.get('paying').dirty || form1.get('paying').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </div>

      <div class="col-lg-12">
        <span class="p-float-label w-100 mb-3">
          <textarea formControlName="opsNotes" id="opsNotes" [rows]="2" pInputTextarea></textarea>
          <label for="opsNotes">Ops Notes</label>
          @for (validation of validationMessages.opsNotes; track validation) {
            <span>
              @if (form1.get('opsNotes').hasError(validation.type) && (form1.get('opsNotes').dirty || form1.get('opsNotes').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
    </div>
  </div>
  <hr>
    <div class="row m-0">
      <div class="col-lg-12">
        <div class="btn-group">
          <div class="button-group">
            <!-- <button pButton *ngIf="reservationId" class="btn-delete p-button-outlined p-button-danger"
          (click)="onFormDelete()">Delete</button> -->
        </div>

        <div class="button-group">
          <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
          @if (!reservationId) {
            <button pButton class="btn-addt p-button" (click)="formAdd()">Add</button>
          }

          <!-- <button pButton *ngIf="reservationId"  class="btn-upt p-button" (click)="formUpdate()">Update</button> -->
        </div>
      </div>
    </div>
  </div>
</div>